import React from 'react'
import {Vehicle} from '../../../../../domain-models'
import {find} from 'lodash'
import {number} from '../../../../../filters'
import Trans from '../../../../../components/Trans'

type Props = {
  vehicle: Vehicle
}
export default function Consumptions({vehicle}: Props) {
  const consumWltp = find(vehicle.consumption, {TestProcedure: 'wltp', Type: 'consumption'})
  const co2Wltp = find(vehicle.consumption, {TestProcedure: 'wltp', Type: 'co2'})

  const consumNedc = find(vehicle.consumption, {TestProcedure: 'nedc', Type: 'consumption'})
  const co2Nedc = find(vehicle.consumption, {TestProcedure: 'nedc', Type: 'co2'})

  const unit = vehicle.Fuel === 5 ? 'kWh/100km' : 'l/100km'

  return <div className='flex flex-col gap-3'>
    <h2 className='text-2xl font-bold'>
      Verbrauch und Emissionen (***)
    </h2>
    <div className='grid grid-cols-1 gap-4'>
      <div>
        <dl className='grid grid-cols-2 gap-4'>
          <dt className={'font-bold'}><Trans>Verbrauch</Trans> <Trans>kombiniert</Trans> (NEFZ)</dt>
          <dd>
            {number(consumNedc?.Combined || vehicle.ConsumCombined, 1, unit) || '-'}
          </dd>


          <dt className={'font-bold'}><Trans>Verbrauch innerorts</Trans> (NEFZ)</dt>
          <dd>
            {number(consumNedc?.Low || vehicle.ConsumIntraUrban, 1, unit) || '-'}
          </dd>

          <dt className={'font-bold'}><Trans>Verbrauch außerorts</Trans> (NEFZ)</dt>
          <dd>
            {number(consumNedc?.Medium || vehicle.ConsumExtraUrban, 1, unit) || '-'}
          </dd>

          <dt className={'font-bold'}><Trans>CO₂-Emission kombiniert</Trans> (NEFZ)</dt>
          <dd>
            {vehicle.Fuel === 5 ? 0 : number(co2Nedc?.Combined || vehicle.EmissionsCo2, 1, unit) || '-'}
          </dd>


          <dt className={'font-bold mt-8'}><Trans>Verbrauch</Trans> <Trans>kombiniert</Trans> (WLTP)</dt>
          <dd className={'mt-8'}>
            {number(consumWltp?.Combined || 0, 1, unit) || '-'}
          </dd>


          <dt className={'font-bold'}><Trans>Verbrauch innerorts</Trans> (WLTP)</dt>
          <dd>
            {number(consumWltp?.Low || 0, 1, unit) || '-'}
          </dd>

          <dt className={'font-bold'}><Trans>Verbrauch außerorts</Trans> (WLTP)</dt>
          <dd>
            {number(consumWltp?.Medium || 0, 1, unit) || '-'}
          </dd>

          <dt className={'font-bold'}><Trans>CO₂-Emission kombiniert</Trans> (WLTP)</dt>
          <dd>
            {vehicle.Fuel === 5 ? 0 : number(co2Wltp?.Combined || vehicle.EmissionsCo2Wltp, 1, unit) || '-'}
          </dd>
        </dl>
      </div>
    </div>
  </div>

}